export default __webpack_public_path__ + "static/media/defaultCategoryIcon.ee900cb8.svg";